'use client';

/** @jsxImportSource @emotion/react */
import {
  Chip,
  FlexItem,
  FlexLayout,
  Icon,
  IconContent,
  LazyBackground,
  useBreakPoints,
  useTheme,
} from '@wci-tech/core-ui';
import { useTranslations } from 'next-intl';
import { useStyles } from './GetInTouch.styles';
import { FaIcons } from '@/constants/faIcons';
import { useThemeMode } from '@/context';
import EnquiryForm from '../enquiry-form/EnquiryForm';
import { getCommonChipStyles } from '@/styles/Common.styles';

const SHARED_ICON_PROPS = {
  size: {
    default: 12,
    md: 16,
    lg: 24,
  },
  color: '#1B2358',
};

const GetInTouch = () => {
  const { isDark } = useThemeMode();
  const { theme } = useTheme();
  const commonChip = getCommonChipStyles(theme);

  const desktopImg = isDark
    ? './images/contactDesktopDark.png'
    : './images/contactDesktopLight.png';
  const tabletImg = isDark ? './images/contactTabletDark.png' : './images/contactTabletLight.png';
  const mobileImg = isDark ? './images/contactMobileDark.png' : './images/contactMobileLight.png';

  const styles = useStyles(isDark);
  const t = useTranslations('GetInTouch');

  return (
    <section css={styles.wrapper} id="contact">
      <LazyBackground
        desktopImgSrc={desktopImg}
        tabletImgSrc={tabletImg}
        mobileImgSrc={mobileImg}
        customStyles={{
          width: '100%',
        }}
      >
        <FlexLayout
          direction="column"
          alignItems="center"
          css={styles.container}
          gap={{
            default: 0,
          }}
        >
          <FlexItem>
            <Chip
              label={t('chipLabel')}
              enableHoverEffect={false}
              customStyles={{
                chipContainer: styles.chipContainer,
                label: commonChip.chipLabel,
              }}
            />
          </FlexItem>

          <FlexItem css={{ width: '100%' }}>
            <FlexLayout padding={{ default: 0 }} columns={12} justifyContent="space-between">
              {/* CONTACT INFO SIDE */}
              <FlexItem css={styles.contactContainer}>
                <FlexLayout
                  direction="column"
                  gap={{ default: 12, md: 14, lg: 16 }}
                  padding={{ default: 0 }}
                >
                  <FlexItem>
                    <IconContent
                      withWrap
                      icon={<Icon name={FaIcons.location} {...SHARED_ICON_PROPS} />}
                      customStyles={{
                        base: styles.iconBadge,
                        left: styles.iconLeft,
                        content: styles.addressText,
                      }}
                    >
                      {t('contactInfo.address')}
                    </IconContent>
                  </FlexItem>
                  <FlexItem>
                    <IconContent
                      withWrap
                      icon={<Icon name={FaIcons.phone} {...SHARED_ICON_PROPS} />}
                      customStyles={{
                        base: styles.iconBadge,
                        left: styles.iconLeft,
                        content: styles.addressText,
                      }}
                    >
                      {t('contactInfo.phone')}
                    </IconContent>
                  </FlexItem>
                  <FlexItem>
                    {/* Email */}
                    <IconContent
                      withWrap
                      icon={<Icon name={FaIcons.email} {...SHARED_ICON_PROPS} />}
                      customStyles={{
                        base: styles.iconBadge,
                        left: styles.iconLeft,
                        content: styles.addressText,
                      }}
                    >
                      {t('contactInfo.email')}
                    </IconContent>
                  </FlexItem>
                  <FlexItem>
                    {/* Hours */}
                    <IconContent
                      withWrap
                      icon={<Icon name={FaIcons.clock} {...SHARED_ICON_PROPS} />}
                      customStyles={{
                        base: styles.iconBadge,
                        left: styles.iconLeft,
                        content: styles.addressText,
                      }}
                    >
                      {t('contactInfo.hours')}
                    </IconContent>
                  </FlexItem>
                </FlexLayout>
              </FlexItem>

              {/* FORM SIDE */}
              <FlexItem>
                <EnquiryForm />
              </FlexItem>
            </FlexLayout>
          </FlexItem>
        </FlexLayout>
      </LazyBackground>
    </section>
  );
};

export default GetInTouch;
